export const selectPricingContext = <T>(
  pricing: Record<string, { contextList: T[]; quantity: string }>,
  quantity: 2 | 4,
): Partial<T> & { quantity: number } => {
  const item = pricing[quantity];
  const context: Partial<T> = item?.contextList.find(Boolean) ?? {};
  return { ...context, quantity: Number(item?.quantity) };
};

/**
 * @see docs/worklog/TW-866-compare-promo/rfc.md
 * @see docs/worklog/TW-866-compare-promo/tfc.md
 */
